import React from "react";
import Sticky from "react-sticky-el";
import { FaClock } from "react-icons/fa";
import { FaTrophy } from "react-icons/fa";
import { FaCrown } from "react-icons/fa";
import { FaHashtag } from "react-icons/fa";
import { FaComments, FaCommentDots } from "react-icons/fa";
import Countdown from 'react-countdown';
import { AuthContext } from "../../context/AuthContext";
import { useContext,useEffect, useState  } from "react";
import { fetchCarComments } from "../../_services/carsService";
import { ToastContext } from "../../context/ToastContext";

const StickyBidCard = ({ car, bidStatus, currentBid, handlePlaceBid,onCommentsClick,commentsCount }) => {

  const now = Date.now();
  const targetTime = new Date(car.auction_expiry).getTime();
  const [error, setError] = useState(null);
  const { showToast } = useContext(ToastContext);


  // Calculate the difference in seconds
  const timeLeftInSeconds = Math.floor((targetTime - now) / 1000); // Convert milliseconds to seconds
  const { isLoggedIn, login, userInfo } = useContext(AuthContext);

  return (
      <div className="bg-body-tertiary card " style={{ padding:"10px" }}>
        <div className="d-flex justify-content-between">
        <div className="mb-0 ">
        <span><FaClock className="text-primary fs-5 fw-bold" /> Expires in</span>
            <h4 className="h5 mb-0">
            <Countdown date={targetTime} /> 
            </h4>
          </div>
          {/* XLR8 Price */}
          <div className="mb-0">
          <span><FaHashtag className="text-primary fs-5 " /> Bids</span>
            <h4 className="h5 mb-0">
              {car.total_bid_count}
            </h4>
          </div>

          {/* Current Bid */}

          {/* Highest Bid */}
          {car.current_bid_amount && (
            <div className="mb-0">
              <span>
             <FaCrown className="text-primary fs-5 fw-bold" /> Highest Bid</span>
              <h4 className="h5 mb-0">
                ${car.current_bid_amount.toLocaleString()}
              </h4>
            </div>
          )}

    <div className="mb-0">
              <span onClick={onCommentsClick} style={{ cursor: 'pointer' }}>
              <FaComments className="text-primary fs-5" />  Comments</span>
              <h4 className="h5 mb-0">
                {commentsCount}
              </h4>
            </div>
        
        

          {/* Place/Update Bid Button */}
          {/*
            Disabling the bid button, if the user is the owne of the car
          */}
          <div>
              <button
                onClick={handlePlaceBid}
                className="btn btn-primary"
                style={{
                  borderRadius: '20px',
                  cursor: 'pointer',
                  height: '40px',
                  width: 'auto',
                  lineHeight: '16px',
                }}
                disabled={car.seller_email === userInfo?.email}
              >
                Place Bid
              </button>
            </div>
        </div>
      </div>
      
  );
};

export default StickyBidCard;
